
/**
 * * \@description for formGroup initial value, use function to handle number zero as the input value.
 * * \@arg type = this.store.form.value name from  
 * ex: { first loan: this.store.form.value.housing_monthlyCost, second loan: obj.housing.monthlyResidenceCost}
 * @param {?} type
 * @return {?}
 */
export function formGroupDefaultValue(type: any): any {
  const /** @type {?} */ typeToNumber = parseInt(type);

  if (typeToNumber) {
    return typeToNumber;
  } else if (typeToNumber === 0) {
    return 0;
  } else {
    return '';
  }
}
